import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { MapPin, Globe } from "lucide-react";
import { majorCities, mediumCities, smallCities } from "@/data/cities";
import { remainingCities } from "@/data/cities/remaining";

export const Cities = () => {
  // Combine all cities into one array
  const allCities = [...majorCities, ...mediumCities, ...smallCities, ...remainingCities];

  return (
    <section className="w-full py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <Badge variant="secondary" className="bg-[#F8F7FF] text-primary text-sm mb-4 flex items-center gap-1 mx-auto w-fit">
              <Globe className="h-4 w-4" />
              Our Service Areas
            </Badge>
            <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6">
              Serving Illinois Communities
            </h2>
            <p className="text-neutral max-w-2xl mx-auto">
              We provide comprehensive insurance solutions across Illinois, with dedicated service in these communities.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {allCities.map((city, index) => (
              <Link
                key={`city-${city.name}-${index}`}
                to={`/city/${city.name.toLowerCase()}`}
                className="group bg-white border border-gray-200 rounded-lg p-4 hover:border-primary hover:shadow-md transition-all duration-200"
              >
                <div className="flex items-center gap-2">
                  <MapPin className="h-4 w-4 text-primary group-hover:scale-110 transition-transform" />
                  <span className="text-sm font-medium text-gray-800 group-hover:text-primary transition-colors">
                    {city.name}
                  </span>
                </div>
                <div className="mt-2">
                  <span className="text-xs text-gray-500">
                    Population: {city.population.toLocaleString()}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cities;
